import Base from './base'

export default class MelodyCustomFields extends Base {
  async getCustomFields() {
    try {
      return this.api.get('custom_fields.json')
    } catch (e) {
      return null
    }
  }
}
